var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCamera = function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    opacity: 0.392
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.852 8.11h-4.5l-2.02-3.63a1.93 1.93 0 0 0-1.495-.8h-9.442a1.88 1.88 0 0 0-1.67.97L14.69 8.189h-4.406v-.971a.94.94 0 0 0-.875-.874H7.642a.88.88 0 0 0-.874.874v.87H4.11a3.54 3.54 0 0 0-3.514 3.537v21.164a3.546 3.546 0 0 0 3.533 3.533h31.743a3.546 3.546 0 0 0 3.533-3.533V11.624a3.56 3.56 0 0 0-3.553-3.514M18.32 5.548l.1-.1h9.335l1.494 2.64H16.827zm19.297 27.24a1.773 1.773 0 0 1-1.767 1.767H4.11a1.773 1.773 0 0 1-1.767-1.767V11.624A1.773 1.773 0 0 1 4.11 9.858h31.743a1.773 1.773 0 0 1 1.767 1.767z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.95 14.284a8.367 8.367 0 1 0 8.367 8.367 8.42 8.42 0 0 0-8.367-8.367m0 14.988a6.62 6.62 0 1 1 6.62-6.62 6.666 6.666 0 0 1-6.62 6.62M12.05 13.39H5.878a.94.94 0 0 0-.874.874v.874a.94.94 0 0 0 .874.874h6.174a.88.88 0 0 0 .874-.874v-.874a.924.924 0 0 0-.877-.87z"
  }))));
};
export { SvgCamera as ReactComponent };
export default "/_next/static/images/camera.svg";